import { ToastContainer, ToastContainerProps } from 'react-toastify';

export function StyledToastContainer(props: ToastContainerProps) {
  return (
    <ToastContainer toastClassName="toast" bodyClassName="body" {...props} />
  );
}
